<template>
  <b-modal
    ref="modal"
    size="xl"
    hide-header
    hide-footer
    centered
    dialog-class="whm-dialog"
    content-class="whm-content"
    body-class="working-hours-modal-body"
    @hidden="onHidden"
  >
    <div class="whm-host">
      <WorkingHoursEditor
        v-if="branchMemberId != null"
        :key="editorKey"
        :clinic-url="$route.params.clinicUrl"
        :branch-url="$route.params.branchUrl"
        :branch-member-id="branchMemberId"
        @close="hide"
      />
    </div>
  </b-modal>
</template>

<script>
import WorkingHoursEditor from "@/components/workingHours/WorkingHoursEditor.vue";

// Modal host for the working-hours editor. Replaces the standalone
// /working-hours route when opened from the UserManage "จัดการแพทย์" tab so the
// user never leaves the page. Remounts the editor per open (:key) for a clean
// month/selection reset and a fresh load. The editor renders its own header
// (doctor avatar, name, month nav, close), so b-modal's chrome is hidden.
export default {
  name: "WorkingHoursModal",
  components: { WorkingHoursEditor },
  data() {
    return {
      branchMemberId: null,
      openCount: 0,
    };
  },
  computed: {
    editorKey() {
      return `${this.branchMemberId}-${this.openCount}`;
    },
  },
  methods: {
    show({ branchMemberId }) {
      this.branchMemberId = branchMemberId;
      this.openCount += 1;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      // Let the host refresh its list/overview — schedule may have changed.
      this.$emit("closed");
      this.branchMemberId = null;
    },
  },
};
</script>

<style>
/* IBM Plex Sans Thai — the editor's typeface (matches the approved design). */
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap");

/* Modal shell: wide, rounded, soft shadow — a calm medical-SaaS surface. */
.whm-dialog {
  max-width: 1180px;
}
.whm-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px -12px hsl(222 30% 14% / 0.42),
    0 8px 24px -10px hsl(222 30% 14% / 0.3);
}
/* Stable height so the editor's flex column (calendar + side panel) fills it
   and scrolls internally instead of growing the page. */
.working-hours-modal-body {
  padding: 0;
}
.working-hours-modal-body .whm-host {
  height: min(820px, 86vh);
  min-height: 480px;
}
</style>
